const ROUTE_NAME = {
  CENTR_PEREVIROK: 'CentrPerevirok',
  CHECK_SELECTION: 'check_selection',
  AUTOTEST: 'Autotest',
  LIST_STO: 'ListSTO',
};

export default ROUTE_NAME;
